import React from "react";
import "./Card.css";
import { CardProps } from "./types";
import { CardArtist } from "./CardArtist";
import { CardDefault } from "./CardDefault";

export const Card: React.FC<CardProps> = ({
  layoutType = "default",
  ...cardProps
}) => {
  if (layoutType === "artist") {
    return <CardArtist {...cardProps} layoutType={layoutType} />;
  }

  return <CardDefault {...cardProps} layoutType={layoutType} />;
};
